export default function ContextCard({
  metadata,
  playlist,
  seed,
  isCollapsed,
  onToggle,
}) {
  if (!metadata) return null;

  return (
    <div className={`context-card ${isCollapsed ? "collapsed" : ""}`}>
      <h2 className="context-toggle" onClick={onToggle}>
        Context
        <span className="toggle-icon">▼</span>
      </h2>
      <div className="context-content">
        <ul>
          <li>
            <strong>Era:</strong> {metadata.era || "All Eras"}
          </li>
          <li>
            <strong>Seed:</strong> {seed ?? metadata.seed ?? "—"}
          </li>
          <li>
            <strong>Cutoff date:</strong> {metadata.cutoff_date}
          </li>
        </ul>
        {playlist?.m3u_text && (
          <p style={{ marginTop: "1em" }}>
            <a
              href={`data:audio/x-mpegurl;charset=utf-8,${encodeURIComponent(
                playlist.m3u_text
              )}`}
              download="phish-setlist.m3u"
              className="download-link"
            >
              📥 Download M3U playlist
            </a>
          </p>
        )}
        <p
          style={{
            marginTop: "1em",
            fontSize: "0.9em",
            color: "var(--muted)",
          }}
        >
          Data source:{" "}
          <a href="https://phish.in/" target="_blank" rel="noopener noreferrer">
            Phish.in
          </a>{" "}
          (MIT License)
        </p>
      </div>
    </div>
  );
}
